import { Outlet } from 'react-router';
import { useIsDesktop, useShouldRetractRightSection } from '@/hooks/use-user-platform';
import { useLayoutStore } from '@/stores/layout-status';
import { useMessageStore } from '@/stores/message';
import cn from '@/utils/merge-class-names';
import GlobalSearchBySessionRoute from './by-session';
import GlobalSearchRoute from './index';
export default function GlobalSearchLayout() {
  const isDesktop = useIsDesktop();
  const { panel } = useLayoutStore();
  const shouldRetractRightSection = useShouldRetractRightSection();
  const messageKey = useMessageStore((s) => s.key);

  if (!isDesktop) {
    return <Outlet />;
  }
  if (!shouldRetractRightSection || messageKey === 'default')
    return (
      <div className={cn('size-full flex')}>
        {panel === 'search' && <GlobalSearchRoute />}
        {panel === 'search-by-session' && <GlobalSearchBySessionRoute />}
      </div>
    );
}
